// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/Login.tsx
// v2.23.0 - Schatten an Wortmarke und Leitsatz wieder entfernt (Inhaber 01.11.2026: 'sieht irgendwie bloed aus').
// v2.22.0 - Leitsatz 'make it happen with estata' klein unter der Wortmarke (15/17 px, 500), Wortmarke bleibt mittig (Inhaber).
// v2.21.0 - Wortmarke mit leichtem Schatten (0 1px 2px 25 % + 0 2px 12px 20 % Schwarz, Inhaber 01.11.2026).
// v2.20.0 - Wortmarke 'estata' ohne Punkt, mittig zwischen oberem Rand und oberem Knopf, Laufweite +0,02 em (Inhaber).
// v2.19.0 - Logo der Startseite als Wortmarke 'estata.' (klein, Inter Black 900) statt Bild (Inhaber 01.11.2026).
// v2.18.0 - Satz der Startseite entfernt (Inhaber 29.10.2026: 'Bau- und Projektmanagement ... raus') - nur Logo, Foto, Knoepfe.
// v2.17.0 - Satz der Startseite: 'Bau- und Projektmanagement' (Inhaber 28.10.2026), alle Sprachen.
// v2.16.0 - Satz ohne Schatten und ohne 'Intelligentes' (Inhaber 27.10.2026): 'Projektmanagement, das Menschen verbindet.'
// v2.15.0 - Hintergrund der Startseite ueber LoginBackdrop: mehrere Fotos, weich ueberblendet (Inhaber 27.10.2026).
// v2.14.0 - Startseite unter dem Anmelde-Ablauf ist fuer VoiceOver und Tastatur stumm (inert + aria-hidden), solange
//           ein Schritt offen ist - vorher las VoiceOver Logo und Knoepfe der Startseite bei jedem Schritt mit.
// v2.13.0 - Passcode wie bei Apple: Texte fuer die Rueckfrage bei "Passcode vergessen?" und die VoiceOver-Ansage.
// v2.12.0 - Adresse der Firma app.estata.com/<kurzname> (FirmLogin): Firma als Eigenschaft, der Name kommt schon mit.
// v2.11.0 - ?firm=<kurzname der Firma> (Inhaber 21.10.2026; Subdomains <kurzname>.app.estata.com spaeter): ohne Sitzung gleich Anmelden mit dem
//           Firmennamen darueber (GET /tenants/by-slug), mit Sitzung und Zugang direkt in diese Firma (preferFirm).
// v2.10.0 - ?signup=<token>: Link aus der Registrierungs-Mail oeffnet den Schritt "Registrierung bestaetigen"
//           (Konto erstellen erst nach Bestaetigung, Inhaber 21.10.2026).
// v2.9.0 - ?oauth=<Anfrage>: eine KI-App (MCP) will sich verbinden - mit Sitzung sofort die Zustimmung (OAuthConsent),
//          sonst Anmelden und danach die Zustimmung; kein Passcode, keine Mandantenwahl (Inhaber 18.10.2026).
// v2.8.0 - Einladungslink mit &project=<id> (Mitarbeiter ohne Passwort, B-6): das Projekt wird gemerkt, nach Passwort + PIN
//          geht es dorthin (loginTargets.rememberNextProject/myestEntry).
// v2.7.0 - Schleier ausserhalb des Startseiten-Rahmens (relative + overflow hidden): in der Home-App liegt er absolut im
//          Dokument (@estata/ui 3.1.0 ScreenFrame) und darf von keinem Rahmen beschnitten werden.
// v2.6.0 - Eine ruhige PIN-Seite (Inhaber, 12.10.2026): immer das Login-Bild (im Ziffernblock), vorab geladen; bei
//          mehreren Mandanten blendet sie weich in die Auswahl ueber (PasscodeVeil), bei einem bleibt sie bis MyEST stehen.
// v2.5.0 - Bild hinter dem Passcode vom Server (MyEST-Einstellungen der Person, fetchPersonBackground) - vorher nur aus
//          dem Speicher des Geraets, dann zeigte die Seite ihr eigenes Bild (Inhaber: "Ich dachte, wir bekommen das Foto").
// v2.4.0 - Passcode mit abgedunkeltem Bild (das MyEST-Bild der Person, sonst das der Login-Seite); nach dem richtigen
//          Code bleibt er stehen, bis MyEST da ist - die Startseite blitzt nicht mehr auf (Inhaber, 12.10.2026).
// v2.3.3 - Falscher Code als Blatt von unten (login.passcodeWrongTitle).
// v2.3.2 - Passcode-Tor schwarz, ohne Hintergrundbild (Inhaber, 12.10.2026).
// v2.3.1 - Leitsatz des Inhabers statt des Aufzaehlungssatzes: "Intelligentes Projektmanagement, das Menschen
//          verbindet." (login.startPitch, sieben Sprachen; 12.10.2026).
// v2.3.0 - Passcode VOR der Mandanten-Wahl (Inhaber, 12.10.2026: "wenn ich mehrere Mandanten habe, dann sollte der
//          Passcode vorher kommen"): bei lebender Sitzung und noch nicht entsperrtem Tab fragt die Seite zuerst den
//          Passcode (PasscodeGate aus @estata/ui, dasselbe Tor wie in MyEST), danach Auswahl bzw. Bereich. MyEST sieht
//          den Tab als entsperrt (markUnlocked) und fragt nicht ein zweites Mal.
// v2.2.0 - Ein sachlicher Satz ueber den Knoepfen, wie bei Nike (Inhaber, 12.10.2026): was man hier findet
//          (login.startPitch, sieben Sprachen). Kein Schleier ueber dem Bild (v2.0.2) - lesbar per Textschatten.
// v2.1.0 - ?register=1&plan=&email= oeffnet Konto erstellen (Schritte in LoginFlow); /signup leitet hierher.
// v2.0.3 - Beide Knoepfe leicht durchscheinend (weiss 85 %, schwarz 45 %, Weichzeichner dahinter; Inhaber, 10.10.2026).
// v2.0.2 - Hintergrundbild unveraendert in voller Farbe, kein Schleier (Inhaber, 10.10.2026: "so lassen, wie es ist").
// v2.0.1 - Hintergrund dunkel (zurueckgenommen).
// v2.0.0 - Startseite nach dem Vorbild Revolut (Inhaber, 10.10.2026: "die
//          Anmeldeseite ist so wie dargestellt mit unserem Logo und dahinter
//          einer Animation"): schwarz, Logo, langsam treibendes Bild dahinter,
//          unten "Konto erstellen" (weiss) und "Anmelden" (dunkel). Kein
//          Fenster mehr - die Schritte sind Vollbild (components/LoginFlow).
//          Mit Sitzung sieht man die Seite nicht (direkt in den Bereich);
//          ?invite= und ?reset= oeffnen den passenden Schritt sofort.
// v1.6.0 - Anmelden/Registrieren statt "Login", in der Sprache des Geraets.
// v1.5.0 - K-9: ?invite=<token> und ?reset=<token> oeffnen das Fenster direkt.
// v1.4.0 - Bereits-eingeloggt-Fall nutzt geteilte Ziel-Logik (lib/loginTargets).

import { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import LoginFlow, { LoginMode } from "../components/LoginFlow.tsx";
import OAuthConsent from "../components/OAuthConsent.tsx";
import { buildTargets, goToTarget, LoginTarget, preferFirm, rememberedFirm, rememberFirm, rememberNextProject } from "../lib/loginTargets.tsx";
import { useLanguage } from "../lang/index.lang.tsx";
import LoginBackdrop from "../components/LoginBackdrop.tsx";
import { isUnlocked, PasscodeGate, PasscodeVeil, preloadPasscodeImage } from "@estata/ui";
import { sessionEntryStep } from "../lib/sessionEntry.ts";
import type { PasscodeGateTexts } from "@estata/ui";

const Login = ({ firm: firmProp }: { firm?: { slug: string; name?: string } } = {}) => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  // Links aus den Mails (K-9): Einladung bzw. neues Passwort.
  const inviteToken = searchParams.get("invite") || undefined;
  // B-6: Einladung ins Projekt - nach Passwort + PIN direkt dorthin (loginTargets.myestEntry)
  if (inviteToken) rememberNextProject(searchParams.get("project"));
  const resetToken = searchParams.get("reset") || undefined;
  // Konto erstellen: Link aus der Bestaetigungs-Mail (Migration 296) - erst damit wird angelegt
  const signupToken = searchParams.get("signup") || undefined;
  // KI-App verbinden (MCP): Anfrage vom System-Backend (/oauth/authorize)
  const oauthRequest = searchParams.get("oauth") || undefined;
  const [consent, setConsent] = useState(false);
  // Adresse der Firma (app.estata.com/<kurzname>, FirmLogin) oder alt /login?firm=<kurzname>
  const firm = firmProp ? rememberFirm(firmProp.slug)
    : searchParams.get("firm") !== null ? rememberFirm(searchParams.get("firm")) : rememberedFirm();
  const [firmName, setFirmName] = useState<string | undefined>(firmProp?.name);
  const hasToken = !!(inviteToken || resetToken || signupToken);
  // Konto erstellen von /pricing oder der alten /signup-Adresse: ?register=1&plan=pro&email=...
  const wantsRegister = searchParams.get("register") === "1";
  const plan = searchParams.get("plan") || "standard";
  const initialEmail = searchParams.get("email") || "";
  const [flow, setFlow] = useState<LoginMode | null>(
    inviteToken ? 'invite' : resetToken ? 'reset' : signupToken ? 'reg-confirm' : wantsRegister ? 'register' : null);
  const [checking, setChecking] = useState(!hasToken);
  // Bei lebender Session mit mehreren Zielen: hier landen die Ziele, der Ablauf beginnt bei der Auswahl.
  const [sessionTargets, setSessionTargets] = useState<LoginTarget[]>([]);
  // Lebende Sitzung, Tab noch zu: erst der Passcode, dann die Ziele (Auswahl oder direkt hinein).
  const [gate, setGate] = useState<{ hasPasscode: boolean; targets: LoginTarget[] } | null>(null);
  // Mehrere Mandanten: die stehende PIN-Seite blendet weich in die Auswahl ueber.
  const [veil, setVeil] = useState(false);
  // Startseite unter dem Ablauf: stumm fuer VoiceOver/Tastatur (inert als DOM-Eigenschaft, React 18 kennt es nicht)
  const startRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = startRef.current as (HTMLDivElement & { inert?: boolean }) | null;
    if (el) el.inert = !!flow;
  }, [flow]);
  // Das Bild der PIN-Seite frueh laden - sie erscheint dann ohne Sprung.
  useEffect(() => { preloadPasscodeImage(); }, []);
  // Name der Firma fuer "ueber Anmelden" - unbekannte Subdomain: einfach die normale Anmeldung, ohne Hinweis.
  useEffect(() => {
    if (!firm || firmProp) return;
    axios.get(`/system/api/v1/tenants/by-slug/${encodeURIComponent(firm)}`)
      .then((res) => setFirmName(res.data?.name || undefined))
      .catch(() => setFirmName(undefined));
  }, [firm]);

  const openTargets = async (found: LoginTarget[]) => {
    // 0/1 Ziel direkt, >=2 Auswahl - die Startseite sieht man nicht.
    if (sessionEntryStep(true, found.length) === 'direct') {
      await goToTarget(found[0] || { kind: 'tenant', label: '' });
      return;
    }
    setSessionTargets(found);
    setFlow('signin');
  };

  // Session-Check beim Laden - nicht mit einem Token aus der Mail: dann zaehlt der Link, nicht die
  // Sitzung, die zufaellig im Browser lebt.
  useEffect(() => {
    if (hasToken) return;
    const checkSession = async () => {
      try {
        const response = await axios.get('/system/api/v1/auth/check', { withCredentials: true });
        if (response.data.authenticated && oauthRequest) {
          setConsent(true);
          setChecking(false);
          return;
        }
        if (response.data.authenticated) {
          const found = preferFirm(buildTargets(response.data.user));
          if (sessionEntryStep(isUnlocked(), found.length) === 'passcode') {
            // Der Passcode gehoert zur Person und zum Geraet - er schliesst auf, die Wahl des Mandanten kommt danach.
            setGate({ hasPasscode: response.data.passcode?.set !== false, targets: found });
            setChecking(false);
            return;
          }
          await openTargets(found);
          setChecking(false);
          return;
        }
      } catch (err) {
        // Nicht eingeloggt oder Fehler -> Startseite zeigen
      }
      // KI-App verbinden oder ueber die Subdomain einer Firma: gleich anmelden, die Startseite braucht es nicht
      if (oauthRequest || firm) setFlow('signin');
      setChecking(false);
    };
    checkSession();
  }, [hasToken]);

  if (checking) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-black">
        <Loader2 className="w-8 h-8 text-white animate-spin" />
      </div>
    );
  }

  if (consent && oauthRequest) {
    return <OAuthConsent requestId={oauthRequest} onSignOut={() => { setConsent(false); setFlow('signin'); }} />;
  }

  if (gate) {
    const texts: PasscodeGateTexts = {
      enterTitle: t("login.passcodeEnterTitle"), forgot: t("login.passcodeForgot"),
      wrongTitle: t("login.passcodeWrongTitle"), wrong: t("login.passcodeWrong"),
      reset: t("login.passcodeReset"), setTitle: t("login.passcodeSetTitle"), repeatTitle: t("login.passcodeRepeatTitle"),
      setSub: t("login.passcodeSetSub"), mismatch: t("login.passcodeMismatch"),
      passwordTitle: t("login.passcodePasswordTitle"), passwordSub: t("login.passcodePasswordSub"),
      password: t("login.password"), next: t("login.next"), wrongPassword: t("login.passcodeWrongPassword"),
      saveFailed: t("login.passcodeSaveFailed"), failed: t("login.passcodeFailed"), delete: t("login.passcodeDelete"),
      progress: t("login.passcodeProgress"), forgotTitle: t("login.passcodeForgotTitle"), forgotText: t("login.passcodeForgotText"),
      forgotConfirm: t("login.passcodeForgotConfirm"), cancel: t("login.passcodeCancel"),
    };
    return (
      <div className="min-h-screen w-full bg-black">
        <PasscodeGate
          hasPasscode={gate.hasPasscode}
          authUrl="/system/api/v1"
          texts={texts}
          onUnlocked={() => {
            const found = gate.targets;
            // Ein Ziel: der Passcode-Bildschirm bleibt stehen, bis MyEST da ist (kein Aufblitzen der Startseite).
            // Mehrere: die Auswahl ersetzt ihn.
            if (sessionEntryStep(true, found.length) === 'direct') { void openTargets(found); return; }
            setVeil(true);
            setGate(null);
            void openTargets(found);
          }}
          onSignedOut={() => window.location.assign("/login")}
        />
      </div>
    );
  }

  return (
    <>
    <div className="relative min-h-screen w-full overflow-hidden bg-black">
      {/* Die Animation dahinter: das Bild in voller Farbe, nicht abgedunkelt (Inhaber, 10.10.2026:
          "du sollst das Hintergrundbild so lassen, wie es ist"), es treibt nur langsam. */}
      <LoginBackdrop />

      <div ref={startRef} aria-hidden={flow ? true : undefined}
           className="relative z-10 flex flex-col min-h-screen max-w-md mx-auto px-5
                      pb-[calc(32px+env(safe-area-inset-bottom))]">
        {/* Wortmarke statt Bild-Logo (Inhaber 01.11.2026: "nur eine Schrift ... in Kleinschrift und fett, maximal
            bold"; ohne Punkt, mittig zwischen oberem Rand und oberem Knopf, Buchstaben etwas weiter) - Inter Black 900.
            Die Flaeche reicht vom oberen Rand des Bildschirms bis zum ersten Knopf, die Schrift steht in ihrer Mitte. */}
        <div className="flex-1 flex items-center justify-center">
          <div className="relative">
            <span className="block text-white text-[44px] sm:text-[52px] leading-none font-black tracking-[0.02em]"
                  data-start-wordmark>
              estata
            </span>
            {/* Leitsatz unter der Wortmarke (Inhaber 01.11.2026), Englisch in jeder Sprache wie ein Produktname.
                Absolut darunter, damit die Wortmarke selbst genau in der Mitte bleibt. */}
            <p className="absolute left-1/2 top-full -translate-x-1/2 mt-3 whitespace-nowrap text-white
                          text-[15px] sm:text-[17px] leading-tight font-medium tracking-[0.01em]"
               data-start-tagline>
              make it happen with estata
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <button
            type="button"
            onClick={() => setFlow('register')}
            className="w-full h-14 rounded-full bg-white/85 backdrop-blur-md text-black text-[17px] font-semibold"
          >
            {t("login.createAccount")}
          </button>
          <button
            type="button"
            onClick={() => setFlow('signin')}
            className="w-full h-14 rounded-full bg-black/45 backdrop-blur-md text-white text-[17px] font-semibold border border-white/20"
          >
            {t("login.signIn")}
          </button>
        </div>
      </div>

      {flow && (
        <LoginFlow
          mode={flow}
          onClose={() => { setFlow(null); setSessionTargets([]); }}
          initialTargets={sessionTargets.length > 0 ? sessionTargets : undefined}
          inviteToken={inviteToken}
          resetToken={resetToken}
          signupToken={signupToken}
          plan={plan}
          initialEmail={initialEmail}
          onSignedIn={oauthRequest ? () => { setFlow(null); setConsent(true); } : undefined}
          firmName={firmName}
        />
      )}
    </div>
    {veil && <PasscodeVeil title={t("login.passcodeEnterTitle")} onDone={() => setVeil(false)} />}
    </>
  );
};

export default Login;
